var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.72 1H1V5.07143C1 5.07143 2.44 5.39714 2.57714 7.20571C2.57714 7.20571 2.62 8.64572 1 9.29714V13.3771H25V9.39143C25 9.39143 23.56 9.06572 23.4229 7.25714C23.4229 7.25714 23.38 5.81714 25 5.16571V1H13.6429",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6943 3.7251H16.6857C15.3507 3.7251 14.2686 4.80729 14.2686 6.14224V8.2251C14.2686 9.56005 15.3507 10.6422 16.6857 10.6422H16.6943C18.0292 10.6422 19.1114 9.56005 19.1114 8.2251V6.14224C19.1114 4.80729 18.0292 3.7251 16.6943 3.7251Z",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6687 5.8851L9.24584 3.7251V10.6422",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89697 10.6431H11.7398",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherIcon);
export default __webpack_public_path__ + "static/media/VoucherIcon.de5d6e4db738148808b4d0352c056f3d.svg";
export { ForwardRef as ReactComponent };